module.exports = __webpack_public_path__ + "img/Boy_020024.a56754a5.png";